import {MenuItemAggregate} from '../../../../../aggregats/menu/menu-item.aggregate';
import {AutorisationsAggregate} from '../../../../../aggregats/autorisation/autorisations.aggregate';
import {AutorisationAggregate} from '../../../../../aggregats/autorisation/autorisation.aggregate';
import {FonctionLogicielle} from '../../../../fonctions-logicielle-constantes';

export const tachesMenuItem: MenuItemAggregate = new MenuItemAggregate(
  'icon-check-square',
  'Tâches',
  null,
  null,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.Taches)]),
);
